import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlatformEnum } from '@panamax/app-state';
import { Button } from '@shared/models/ellipsis-option.model';
import { MPPMenuItem } from '@usf/ngrx-tools/lib/model/mpp-menu-item';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
})
export class SubMenuComponent {
  @Input() items: MPPMenuItem[];
  @Input() platform: PlatformEnum;
  @Input() currentPage: string;
  @Input() translateService: TranslateService;
  @Output() clickEvent = new EventEmitter<MPPMenuItem>();
  menuButtons;

  platformRef = PlatformEnum;
  isOpen = false;
  constructor() {}

  onClick(item: MPPMenuItem) {
    this.closeMenu();
    setTimeout(() => {
      if (!item.isSelected) this.clickEvent.emit(item);
    }, 100);
  }

  openMenu() {
    this.menuButtons = [];
    this.items.forEach(item => {
      this.menuButtons.push({
        text: this.translateService.instant(item.label),
        handler: () => {
          this.onClick(item);
        },
      } as Button);
    });
    this.isOpen = true;
  }

  closeMenu() {
    this.isOpen = false;
  }
}
